import { useMutation } from '@tanstack/react-query';
import { authService } from '../services';

/** Solicita o link de redefinicao de senha. */
export function useForgotPassword() {
  return useMutation({
    mutationFn: (email: string) => authService.forgotPassword(email),
  });
}

/** Redefine a senha a partir do token recebido por e-mail. */
export function useResetPassword() {
  return useMutation({
    mutationFn: (input: { token: string; password: string }) => authService.resetPassword(input),
  });
}
